// Mock data matching DynamoDB structure - will be replaced with API calls in Phase 3

export const mockProject = {
  slug: "bassoon-session",
  project_name: "Bassoon Session",
  musician_name: "Session Musician",
  musician_email: "",
  status: "active",
  created_at: "2026-01-15T22:40:24.768580Z",
  updated_at: "2026-01-15T22:45:27.265420Z",
  
  general_guidelines: `This set of scores and instructions is designed to create a collection of high-quality recorded audio samples - tools composers and producers use to craft music.

You will be recording a series of notes and intervals using various techniques, dynamics, and articulations. The scores may feel a little strange/boring, because they are designed to capture a wide range of specific sounds - like sustained notes, legato transitions, and short articulations.

Audio Format: Deliver recordings in WAV format, 24-bit, 48kHz.

Clean Recording: Avoid any extraneous noise (e.g., shuffling, clicks, etc.).

Follow instructions under each recording item carefully.

Microphone Distance: Maintain a consistent distance from the microphone throughout the recording. For example, if you start at 6 inches away, ensure you stay at that distance. It's easy to unintentionally drift farther away (e.g., 2 feet) over long sessions, so be mindful of this to maintain consistent sound quality.

No Post-Processing: Do not tune, apply reverb, EQ, or any form of audio processing. The recordings should remain raw and unedited.`,

  articulation_explanations: {
    "Legato": "For these articulations, you'll be recording legato intervals. The scores consist of sets of three notes connected by slurs. Each set of three must be legato; smoothly and connected without break.",
    "Longs": "These articulations consist of one long sustained note per pitch in your instrument's range. Play each note using the specific articulations and dynamics instructed below.",
    "Shorts": "Short articulation scores consists of 40 repeated eighth notes on each note of your instrument's range.\n\n• Ringing out: Let the final note of each set decay completely to silence. Capturing this natural fade/reverb in your recording space is essential.\n\n• Tempo: Follow the general tempo marking, but timing can be loose. Prioritize clear articulation over precise timing. No metronome needed.",
    "Short Layer": "Short layer articulation focuses on velocity-based dynamics with precise timing and controlled note lengths."
  },

  format_requirements: {
    sample_rate: 48000,
    bit_depth: 24,
    channels: 1
  },

  checklist: {
    sample_approved: false,
    full_recording_uploaded: false,
    full_recording_approved: false,
    payment_processed: false
  },

  deliverables: [
    {
      id: "deliverable-1",
      articulation_name: "Legato Non-Vibrato - pp - extra soft",
      score_type: "Legato",
      dynamic_level: "pp",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/legato_non-vibrato_legato.pdf",
      expected_filename: "Legato_Non-Vibrato_pp_extra_soft.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "not_uploaded",
      review_notes: null,
      review_status: null,
      reviewed_at: null,
      uploaded_file_url: null,
      uploaded_at: null
    },
    {
      id: "deliverable-2",
      articulation_name: "Legato Non-Vibrato - p - soft",
      score_type: "Legato",
      dynamic_level: "p",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/legato_non-vibrato_legato.pdf",
      expected_filename: "Legato_Non-Vibrato_p_soft.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "pending_review",
      review_notes: null,
      review_status: null,
      reviewed_at: null,
      uploaded_file_url: "https://uploads.auddict.com/bassoon-session/Legato_Non-Vibrato_p_soft.wav",
      uploaded_at: "2026-01-15T23:00:00.000Z"
    },
    {
      id: "deliverable-3",
      articulation_name: "Legato Non-Vibrato - mf - medium loud",
      score_type: "Legato",
      dynamic_level: "mf",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/legato_non-vibrato_legato.pdf",
      expected_filename: "Legato_Non-Vibrato_mf_medium_loud.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "approved",
      review_notes: null,
      review_status: "approved",
      reviewed_at: "2026-01-16T10:00:00.000Z",
      uploaded_file_url: "https://uploads.auddict.com/bassoon-session/Legato_Non-Vibrato_mf_medium_loud.wav",
      uploaded_at: "2026-01-15T23:05:00.000Z"
    },
    {
      id: "deliverable-4",
      articulation_name: "Legato Non-Vibrato - ff - extra loud",
      score_type: "Legato",
      dynamic_level: "ff",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/legato_non-vibrato_legato.pdf",
      expected_filename: "Legato_Non-Vibrato_ff_extra_loud.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "revision_requested",
      review_notes: "Too much room reverb, please move closer to the mic",
      review_status: "revision_requested",
      reviewed_at: "2026-01-16T10:05:00.000Z",
      uploaded_file_url: "https://uploads.auddict.com/bassoon-session/Legato_Non-Vibrato_ff_extra_loud.wav",
      uploaded_at: "2026-01-15T23:10:00.000Z"
    },
    {
      id: "deliverable-5",
      articulation_name: "Legato Vibrato - p - soft",
      score_type: "Legato",
      dynamic_level: "p",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/legato_vibrato_legato.pdf",
      expected_filename: "Legato_Vibrato_p_soft.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "approved",
      review_notes: null,
      review_status: "approved",
      reviewed_at: "2026-01-16T10:10:00.000Z",
      uploaded_file_url: "https://uploads.auddict.com/bassoon-session/Legato_Vibrato_p_soft.wav",
      uploaded_at: "2026-01-15T23:15:00.000Z"
    },
    {
      id: "deliverable-6",
      articulation_name: "Legato Vibrato - f - loud",
      score_type: "Legato",
      dynamic_level: "f",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/legato_vibrato_legato.pdf",
      expected_filename: "Legato_Vibrato_f_loud.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "not_uploaded",
      review_notes: null,
      review_status: null,
      reviewed_at: null,
      uploaded_file_url: null,
      uploaded_at: null
    },
    {
      id: "deliverable-7",
      articulation_name: "Sustains Non-Vibrato - pp - extra soft",
      score_type: "Longs",
      dynamic_level: "pp",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/sustains_non-vibrato_longs.pdf",
      expected_filename: "Sustains_Non-Vibrato_pp_extra_soft.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "not_uploaded",
      review_notes: null,
      review_status: null,
      reviewed_at: null,
      uploaded_file_url: null,
      uploaded_at: null
    },
    {
      id: "deliverable-8",
      articulation_name: "Sustains Non-Vibrato - p - soft",
      score_type: "Longs",
      dynamic_level: "p",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/sustains_non-vibrato_longs.pdf",
      expected_filename: "Sustains_Non-Vibrato_p_soft.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "approved",
      review_notes: null,
      review_status: "approved",
      reviewed_at: "2026-01-16T11:00:00.000Z",
      uploaded_file_url: "https://uploads.auddict.com/bassoon-session/Sustains_Non-Vibrato_p_soft.wav",
      uploaded_at: "2026-01-16T00:00:00.000Z"
    },
    {
      id: "deliverable-9",
      articulation_name: "Staccato",
      score_type: "Shorts",
      dynamic_level: "",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/staccato_shorts.pdf",
      expected_filename: "Staccato.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "rejected",
      review_notes: "Audio clipping detected at 0:24 and 0:45. Please re-record with lower input gain.",
      review_status: "rejected",
      reviewed_at: "2026-01-16T11:05:00.000Z",
      uploaded_file_url: "https://uploads.auddict.com/bassoon-session/Staccato.wav",
      uploaded_at: "2026-01-16T00:05:00.000Z"
    },
    {
      id: "deliverable-10",
      articulation_name: "Staccatissimo",
      score_type: "Shorts",
      dynamic_level: "",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/staccatissimo_shorts.pdf",
      expected_filename: "Staccatissimo.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "not_uploaded",
      review_notes: null,
      review_status: null,
      reviewed_at: null,
      uploaded_file_url: null,
      uploaded_at: null
    },
    {
      id: "deliverable-11",
      articulation_name: "Key Noises",
      score_type: "Short Layer",
      dynamic_level: "",
      score_url: "https://cdn.auddict.com/scores/Bassoon_Session/scores/key_noises_short_layer.pdf",
      expected_filename: "Key_Noises.wav",
      instructions: "",
      minimum_duration_seconds: 60,
      status: "not_uploaded",
      review_notes: null,
      review_status: null,
      reviewed_at: null,
      uploaded_file_url: null,
      uploaded_at: null
    }
  ]
};

// ============================================
// Utility functions for working with project data
// ============================================

/**
 * Get overall project stats
 */
export const getProjectStats = (project) => {
  const deliverables = project.deliverables || [];
  const total = deliverables.length;
  const uploaded = deliverables.filter(d => d.status !== 'not_uploaded').length;
  const approved = deliverables.filter(d => d.status === 'approved').length;
  const needsAttention = deliverables.filter(d => 
    d.status === 'revision_requested' || d.status === 'rejected'
  ).length;
  
  return { total, uploaded, approved, needsAttention };
};

/**
 * Get unique score types from deliverables (preserves order of first appearance)
 */
export const getScoreTypes = (project) => {
  const deliverables = project.deliverables || [];
  const seen = new Set();
  const scoreTypes = [];
  
  deliverables.forEach(d => {
    if (!seen.has(d.score_type)) {
      seen.add(d.score_type);
      scoreTypes.push(d.score_type);
    }
  });
  
  return scoreTypes;
};

/**
 * Get deliverables grouped by score_type
 */
export const getDeliverablesByScoreType = (project, scoreType) => {
  const deliverables = project.deliverables || [];
  return deliverables.filter(d => d.score_type === scoreType);
};

/**
 * Get stats for a specific score type group
 */
export const getScoreTypeStats = (project, scoreType) => {
  const deliverables = getDeliverablesByScoreType(project, scoreType);
  const total = deliverables.length;
  const uploaded = deliverables.filter(d => d.status !== 'not_uploaded').length;
  const approved = deliverables.filter(d => d.status === 'approved').length;
  const needsAttention = deliverables.filter(d => 
    d.status === 'revision_requested' || d.status === 'rejected'
  ).length;
  
  return { total, uploaded, approved, needsAttention };
};

/**
 * Get the explanation text for a score type
 */
export const getScoreTypeExplanation = (project, scoreType) => {
  return project.articulation_explanations?.[scoreType] || null;
};

/**
 * Extract base articulation name (without dynamic suffix)
 * e.g., "Legato Non-Vibrato - pp - extra soft" -> "Legato Non-Vibrato"
 * e.g., "Staccato" -> "Staccato" (no dynamic)
 */
export const getBaseArticulationName = (deliverable) => {
  const name = deliverable.articulation_name;
  // If there's a dynamic level, the format is "Name - dynamic - description"
  // We want to extract just "Name"
  if (deliverable.dynamic_level) {
    const parts = name.split(' - ');
    return parts[0];
  }
  return name;
};

/**
 * Get dynamic display name from a deliverable
 * e.g., "Legato Non-Vibrato - pp - extra soft" with dynamic_level "pp" -> "pp - extra soft"
 * Returns null if no dynamic
 */
export const getDynamicDisplayName = (deliverable) => {
  if (!deliverable.dynamic_level) return null;
  const name = deliverable.articulation_name;
  const baseName = getBaseArticulationName(deliverable);
  // Remove base name and the " - " separator
  const dynamicPart = name.slice(baseName.length + 3);
  return dynamicPart;
};

/**
 * Group deliverables by articulation (based on score_url which is shared per articulation)
 * Returns array of articulation objects with their dynamics
 */
export const groupDeliverablesByArticulation = (deliverables) => {
  const articulations = [];
  const seen = new Map(); // score_url -> articulation index
  
  deliverables.forEach(deliverable => {
    const baseArticulation = getBaseArticulationName(deliverable);
    const key = deliverable.score_url; // Use score_url as the grouping key
    
    if (seen.has(key)) {
      // Add to existing articulation's dynamics
      const articulationIndex = seen.get(key);
      articulations[articulationIndex].dynamics.push(deliverable);
      if (!articulations[articulationIndex].guide_url && deliverable.guide_url) {
        articulations[articulationIndex].guide_url = deliverable.guide_url;
      }
    } else {
      // Create new articulation
      const newArticulation = {
        id: `articulation-${articulations.length + 1}`,
        name: baseArticulation,
        score_url: deliverable.score_url,
        guide_url: deliverable.guide_url || null,
        instructions: deliverable.instructions,
        dynamics: [deliverable]
      };
      seen.set(key, articulations.length);
      articulations.push(newArticulation);
    }
  });
  
  return articulations;
};

/**
 * Get stats for an articulation (group of dynamics)
 */
export const getArticulationStats = (articulation) => {
  const dynamics = articulation.dynamics || [];
  const total = dynamics.length;
  const approved = dynamics.filter(d => d.status === 'approved').length;
  const needsAttention = dynamics.filter(d => 
    d.status === 'revision_requested' || d.status === 'rejected'
  ).length;
  
  return { total, approved, needsAttention };
};

/**
 * Format sample rate for display (e.g., 48000 -> "48kHz")
 */
export const formatSampleRate = (sampleRate) => {
  return `${sampleRate / 1000}kHz`;
};

/**
 * Format bit depth for display (e.g., 24 -> "24-bit")
 */
export const formatBitDepth = (bitDepth) => {
  return `${bitDepth}-bit`;
};

/**
 * Get formatted audio requirements string
 */
export const getAudioRequirements = (project) => {
  const { sample_rate, bit_depth } = project.format_requirements || {};
  if (!sample_rate || !bit_depth) return "WAV format";
  return `WAV file, ${formatBitDepth(bit_depth)} depth, ${formatSampleRate(sample_rate)} sample rate`;
};
